module.exports = __webpack_public_path__ + "static/media/canes-3.7b5f2386.png";